import React, { useState } from 'react';
import style from './data-labelling.module.scss';
import { IntentsList } from './IntentsList';
import { GroupingsList } from './GroupingsLists';
import { useQuery, useAppAndBranchId } from '../../../hooks';
import { Entity as TEntity } from '../types'
import { api } from '../api';

export function DataLabelling() {
	const [intentId, setIntentId] = useState('');
	const [appId, branchId] = useAppAndBranchId()
  const { data: entities } = useQuery<TEntity[]>(() => {
    return api.getSchema(appId, branchId, "entity")
  }, branchId)

  return (
		<div className={style.dataLabelling}>
			<Header />
			<div className={style.main}>
				<IntentsList intentId={intentId} setIntentId={setIntentId} />
				<GroupingsList intentId={intentId} entities={entities} />
			</div>
		</div>
  )
}

function Header() {
	return (
		<div className={style.header}>
			<h1>Data Labelling</h1>
			<p className={style.desc}>
				Select an intent, provide a user utterance example, label entities, then
				proceed to model creation in Training.
			</p>
			<hr style={{ borderTop: '1px solid rgba(149, 171, 211, 0.30)' }} />
		</div>
	);
}
